module.exports = __webpack_public_path__ + "img/adviser-h.a805cf8a.svg";